export default __webpack_public_path__ + "static/media/swimlane-horizontal.a483f4d6.png";